var style = {"z-snackbar":"z-snackbar","z-alert__content":"z-alert__content","z-alert__btn":"z-alert__btn","z-snackbar--anim-in":"z-snackbar--anim-in","pp-anim-snackbar-slide-in":"pp-anim-snackbar-slide-in","z-snackbar--anim-out":"z-snackbar--anim-out","pp-anim-snackbar-fade-out":"pp-anim-snackbar-fade-out"};

export { style as default };
//# sourceMappingURL=Snackbar.module.scss.js.map
